import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import firebase from "../../Firebase";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import matchSorter from "match-sorter";
import Modal from "react-modal";

import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
class RegularTables extends React.Component {
  constructor() {
    super();
    this.state = {
      datos: [],
      ft: [],
      op: [],
      loading: true,
      modalIsOpen: false,
      password: "",
      ordenPedido: "",
      color: "",
      doc: "",
      acabadoData: [],
    };
  }
  async loadData() {
    await firebase
      .firestore()
      .collection("costura")
      .orderBy("order", "desc")
      .get()
      .then((querySnapshot) => {
        //let datos = [];

        const data = querySnapshot.docs.reduce((acc, data) => {
          const item = data.data();
          const itemIndex = acc.findIndex((accItem) => accItem.op === item.op);
          const cantidadCorte = item.cantCorte;
          const {
            cantEntrada,
            cantSalida,
            fechaEntrada,
            fechaSalida,
            servicio,
          } =
            item.otros && item.otros.length
              ? item.otros[0]
              : {
                  cantEntrada: "",
                  cantSalida: "",
                  fechaEntrada: "",
                  fechaSalida: "",
                  servicio: "",
                };
          const entrada = cantEntrada;
          const salida = cantSalida;
          const fechaEntrada1 = fechaEntrada;
          const fechaSalida1 = fechaSalida;

          let newItem = [{}];

          if (itemIndex >= 0) {
            newItem = {
              ...acc[itemIndex],
              otros: acc[itemIndex].otros.concat({
                color: item.color,
                cantidadCortes: cantidadCorte,
                estado: [item.estado.concat(cantidadCorte, entrada)],
                entrega: item.entrega,
                edit: [
                  item.index,
                  item.op,
                  item.color,
                  item.estado && item.estado.length ? item.estado[0] : "",
                  !item.isEditable,
                  cantidadCorte,
                  entrada,
                  salida,
                ],
                index: item.estado.concat(item.index, !item.isEditable, [
                  item.estado.concat(cantidadCorte, entrada),
                ]),
                cantEntrada: entrada,
                cantSalida: salida,
                fechaEntrada: fechaEntrada1,
                fechaSalida: fechaSalida1,
                servicios: servicio,
              }),
            };
            acc.splice(itemIndex, 1, newItem);
          } else {
            newItem = {
              corteFechaIngreso: item.corteFechaIngreso,
              op: item.op,
              cx: item.cx,
              ft: item.ft,
              b: item.b,
              cliente: item.cliente,
              descripcion: item.descripcion,
              otros: [
                {
                  color: item.color,
                  cantidadCortes: cantidadCorte,
                  estado: [item.estado.concat(cantidadCorte, entrada)],
                  entrega: item.entrega,
                  edit: [
                    item.index,
                    item.op,
                    item.color,
                    item.estado && item.estado.length ? item.estado[0] : "",
                    !item.isEditable,
                    cantidadCorte,
                    entrada,
                    salida,
                  ],
                  index: item.estado.concat(item.index, !item.isEditable, [
                    item.estado.concat(cantidadCorte, entrada),
                  ]),
                  cantEntrada: entrada,
                  cantSalida: salida,
                  fechaEntrada: fechaEntrada1,
                  fechaSalida: fechaSalida1,
                  servicios: servicio,
                },
              ],
            };
            acc.push(newItem);
          }

          return acc;
        }, []);

        this.setState({ data, loading: false });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  }
  componentWillMount() {
    this.loadData();
  }

  openModal(value) {
    this.setState({
      modalIsOpen: true,
      doc: value[0],
      ordenPedido: value[1],
      colorState: value[2],
      estado: value[3],
      isEditable: value[4],
      cantidadCorte: value[5],
      entrada: value[6],
      salida: value[7],
    });
  }

  closeModal(e) {
    e.preventDefault();
    this.setState({ modalIsOpen: false });
  }

  linkToEdit = (e) => {
    e.preventDefault();
    this.state.password === "pcpedit246."
      ? this.props.history.push({
          pathname: "/Costura/EditCostura",
          state: {
            doc: this.state.doc,
            ordenPedido: this.state.ordenPedido,
            colorState: this.state.colorState,
            estado: this.state.estado,
            isEditable: this.state.isEditable,
            cantidadCorte: this.state.cantidadCorte,
            entrada: this.state.entrada,
            salida: this.state.salida,
          },
        })
      : alert("Wrong password, try again");
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  borrar = (value) => {
    const op = value[1];
    const col = value[2];
    const estadoCostura = value[0];
    const newEstado = value[value.length - 1]
      .slice(0, value[value.length - 1].length - 1)
      .concat(0)
      .map((item, idx) => (idx === 0 ? (item = "Nuevo") : item));
    const estado = value
      .slice(0, 3)
      .map((item, idx) => (idx === 0 ? (item = "Nuevo") : item));
    firebase
      .firestore()
      .collection("costura")
      .doc(value[3])
      .update({
        isEditable: true,
        estado,
        otros: [],
        entrega: "",
      });
    firebase
      .firestore()
      .collection("corte")
      .where("op", "==", op)
      .where("color", "==", col)
      .get()
      .then((qs) => {
        qs.forEach((doc) => {
          firebase
            .firestore()
            .collection("corte")
            .doc(doc.id)
            .update({
              isEditable: true,
            });
        });
      });

    const dataUpdated = this.state.data.map((item) => {
      if (item.op === op) {
        const otros = item.otros;
        const index = otros.findIndex((item) => item.color === col);
        otros.splice(index, 1, {
          ...otros[index],
          cantEntrada: "",
          cantSalida: "",
          fechaEntrada: "",
          fechaSalida: "",
          servicios: "",
          estado: [newEstado],
          index: estado.concat(value[3]),
          otros: [],
          entrega: "",
          edit: [value[3], op, col, estado, true],
        });
      }
      return item;
    });

    this.setState({ data: dataUpdated });

    firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          firebase
            .firestore()
            .collection("comercial")
            .doc(doc.id)
            .update({
              otros: doc.data().otros.map((v) => {
                if (v.color === col) {
                  delete v.costura;
                  return v;
                }
                return v;
              }),
            });
        });
      });

    firebase
      .firestore()
      .collection("ing")
      .where("op", "==", op)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const status = "Corte";
          firebase
            .firestore()
            .collection("ing")
            .doc(doc.id)
            .update({
              otros: doc.data().otros.map((v) => {
                if (v.color === col) {
                  return {
                    ...v,
                    status: [status],
                  };
                }
                return v;
              }),
            });
        });
      });

    if (estadoCostura === "Listo") {
      try {
        firebase
          .firestore()
          .collection("acabados")
          .where("op", "==", op)
          .where("color", "==", col)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              firebase
                .firestore()
                .collection("acabados")
                .doc(doc.id)
                .delete();
            });
          });
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };

  render() {
    const { data, loading } = this.state;

    const mainCostura = [
      {
        headerStyle: { backgroundColor: "#F16035", color: "white" },
        columns: [
          {
            Header: "Fecha Corte",
            headerStyle: { fontWeight: "bold" },
            width: 120,
            accessor: "corteFechaIngreso",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.CONTAINS,
                    key: "corteFechaIngreso",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Orden de Producción(OP)",
            width: 252,
            headerStyle: { fontWeight: "bold" },
            accessor: "op",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "op" }],
              }),
            filterAll: true,
          },
          {
            Header: "",
            accessor: "cx",
            headerStyle: { fontWeight: "bold" },
            width: 30,
            Cell: (row) => (
              <div>
                {row.value && Array.isArray(row.value) && row.value.length ? (
                  <span
                    style={{
                      width: "10px",
                      height: "100%",
                    }}
                  >
                    <a
                      href={row.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
                        style={{ width: "16px" }}
                        alt=""
                      />
                    </a>
                  </span>
                ) : null}
              </div>
            ),
          },
          {
            Header: "F.Tecnica",
            width: 100,
            headerStyle: { fontWeight: "bold" },
            accessor: "ft",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [{ threshold: matchSorter.rankings.CONTAINS, key: "ft" }],
              }),
            filterAll: true,
          },
          {
            Header: "",
            headerStyle: { fontWeight: "bold" },
            accessor: "b",
            width: 30,
            Cell: (row) => (
              <div>
                {row.value && Array.isArray(row.value) && row.value.length ? (
                  <span
                    style={{
                      width: "10px",
                      height: "100%",
                    }}
                  >
                    <a
                      href={row.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://cdn3.iconfinder.com/data/icons/muksis/128/pdf-128.png"
                        style={{ width: "16px" }}
                        alt=""
                      />
                    </a>
                  </span>
                ) : null}
              </div>
            ),
          },
          {
            Header: "Cliente",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "cliente",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.STARTS_WITH,
                    key: "cliente",
                  },
                ],
              }),
            filterAll: true,
          },

          {
            Header: "Descripcion",
            headerStyle: { fontWeight: "bold" },
            width: 340,
            accessor: "descripcion",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.STARTS_WITH,
                    key: "descripcion",
                  },
                ],
              }),
            filterAll: true,
          },
        ],
      },
    ];

    const subCostura = [
      {
        Header: "Costura",
        headerStyle: { backgroundColor: "#F16035", color: "white" },
        columns: [
          {
            Header: "Color",
            headerStyle: { fontWeight: "bold" },
            width: 150,
            accessor: "color",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  { threshold: matchSorter.rankings.STARTS_WITH, key: "color" },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Cantidad",
            headerStyle: { fontWeight: "bold" },
            width: 100,
            accessor: "cantidadCortes",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.STARTS_WITH,
                    key: "cantidadCortes",
                  },
                ],
              }),
            filterAll: true,
          },
          {
            Header: "Servicio",
            headerStyle: { fontWeight: "bold" },
            accessor: "servicios",
          },
          {
            Header: "N° Guia TexCross",
            headerStyle: { fontWeight: "bold" },
            accessor: "numGuiaTex",
          },
          {
            Header: "N° Guia Servicio",
            headerStyle: { fontWeight: "bold" },
            accessor: "numGuiaSer",
          },
          {
            Header: "Fecha Ingreso",
            headerStyle: { fontWeight: "bold" },
            accessor: "fechaEntrada",
          },
          {
            Header: "Cantidad Ingresada",
            headerStyle: { fontWeight: "bold" },
            accessor: "cantEntrada",
          },

          {
            Header: "Fecha Entrega",
            headerStyle: { fontWeight: "bold" },
            accessor: "fechaSalida",
          },
          {
            Header: "Cantidad Salida",
            headerStyle: { fontWeight: "bold" },
            accessor: "cantSalida",
          },
          {
            Header: "Estado",
            headerStyle: { fontWeight: "bold" },
            width: 120,
            accessor: "estado",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.STARTS_WITH,
                    key: "estado",
                  },
                ],
              }),
            filterAll: true,
            Cell: (row) => (
              <div className="text-center">
                {row.value[0][0] === "Nuevo" ? (
                  <Link
                    to={{
                      pathname: "/Costura/RegistroDirecto",
                      state: {
                        ordenPedido: row.value[0][1],
                        colorState: row.value[0][2],
                        cantidadCorte: row.value[0][3],
                        entrada: row.value[0][4],
                      },
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#F16035",
                        width: "70%",
                        textAlign: "center",
                        borderRadius: "10px",
                        color: "white",
                        margin: "0px",
                        padding: "5px",
                      }}
                    >
                      {row.value[0][0]}
                    </Button>
                  </Link>
                ) : row.value[0][0] === "En Curso" ? (
                  <Link
                    to={{
                      pathname: "/Costura/RegistroActDirecto",
                      state: {
                        ordenPedido: row.value[0][1],
                        colorState: row.value[0][2],
                        cantidadCorte: row.value[0][3],
                        entrada: row.value[0][4],
                      },
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#FF7e00",
                        width: "70%",
                        textAlign: "center",
                        borderRadius: "10px",
                        color: "white",
                        margin: "0px",
                        padding: "5px",
                      }}
                    >
                      {row.value[0][0]}
                    </Button>
                  </Link>
                ) : (
                  <span
                    style={{
                      backgroundColor: "green",
                      width: "100%",
                      borderRadius: "10px",
                      padding: "6px",
                      color: "white",
                    }}
                  >
                    {row.value[0][0]}
                  </span>
                )}
              </div>
            ),
          },
          {
            Header: "Entrega",
            headerStyle: { fontWeight: "bold", fontSize: "12px" },
            width: 120,
            accessor: "entrega",
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, {
                keys: [
                  {
                    threshold: matchSorter.rankings.STARTS_WITH,
                    key: "entrega",
                  },
                ],
              }),
            filterAll: true,
            Cell: (row) => (
              <span
                style={{
                  backgroundColor:
                    row.value === "Completo"
                      ? "green"
                      : row.value === "Incompleto"
                      ? "orange"
                      : "white",
                  color: "white",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  padding: "5px",
                  fontSize: "0.9em",
                }}
              >
                {row.value}
              </span>
            ),
          },
          {
            Header: "Editar",
            accessor: "edit",
            width: 80,
            headerStyle: { fontWeight: "bold" },
            filterMethod: (filter, rows) =>
              matchSorter(rows, filter.value, { keys: ["edit"] }),
            filterAll: true,
            Cell: (row) => (
              <Button
                style={{
                  backgroundColor: "orange",
                  width: "100%",
                  textAlign: "center",
                  borderRadius: "10px",
                  color: "white",
                  fontWeight: "bold",
                  margin: "0px",
                  padding: "5px",
                }}
                disabled={
                  row.value[3] === "Nuevo" || row.value[4] ? true : false
                }
                onClick={() => this.openModal(row.value)}
              >
                Editar
              </Button>
            ),
          },
          {
            Header: "Borrar",
            headerStyle: { fontWeight: "bold" },
            width: 80,
            accessor: "index",
            Cell: (row) => (
              <div className="text-center">
                {
                  <Button
                    style={{
                      backgroundColor: "red",
                      width: "100%",
                      textAlign: "center",
                      borderRadius: "10px",
                      color: "white",
                      margin: "0px",
                      padding: "5px",
                    }}
                    disabled={
                      row.value[0] === "Nuevo" || row.value[4] ? true : false
                    }
                    onClick={(e) =>
                      window.confirm("ESTAS SEGURO QUE QUIERES BORRAR?") &&
                      this.borrar(row.value)
                    }
                    type="button"
                  >
                    Borrar
                  </Button>
                }
              </div>
            ),
          },
        ],
      },
    ];
    return (
      <div className="content">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="text-center">
                  Seguimiento de Procesos Costura
                </CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={data}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value
                  }
                  columns={mainCostura}
                  loading={loading}
                  loadingText="POR FAVOR, ESPERE UN MOMENTO"
                  noDataText="Sin Registros"
                  defaultPageSize={10}
                  style={{ textAlign: "center" }}
                  previousText="Atras"
                  nextText="Siguiente"
                  pageText="Pagina"
                  ofText="de"
                  minRows={0}
                  rowsText="filas"
                  SubComponent={(row) => {
                    return (
                      <div style={{ padding: "10px" }}>
                        <ReactTable
                          data={row.original.otros}
                          columns={subCostura}
                          noDataText="Ingrese un registro en Costura"
                          pageSize={row.original.otros.length}
                          showPagination={false}
                          style={{
                            textAlign: "center",
                            margin: "10px 0 35px 0",
                          }}
                        />
                      </div>
                    );
                  }}
                />
                <br />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <h2>Enter a password</h2>
          <form>
            <input
              type="password"
              value={this.state.password}
              name="password"
              onChange={this.onChange}
              style={{ border: "1px solid black" }}
            />

            <button
              onClick={(e) => this.linkToEdit(e)}
              autoFocus
              style={{
                borderRadius: "5px",
                padding: "2px",
                margin: "10px",
                backgroundColor: "#58b368",
                border: "2px solid black",
                cursor: "pointer",
              }}
            >
              Submit
            </button>
            <button
              onClick={(e) => this.closeModal(e)}
              style={{
                borderRadius: "5px",
                padding: "2px",
                margin: "10px",
                backgroundColor: "#ca3e47",
                border: "2px solid black",
                cursor: "pointer",
              }}
            >
              Close
            </button>
          </form>
        </Modal>
      </div>
    );
  }
}

export default RegularTables;
